<template>
  <section class="wrapper">
    <h2 class="title">Página no encontrada</h2>
  </section>
</template>

<style lang="sass" scoped>
.wrapper
  display: grid
  place-content: center
.title
  margin: 64px
  text-align: center
</style>
